import compareDates, {
  DateMonthYearValue,
} from "../../CursorStats/StoreCursorTravel/utils";
import { ClickStatData } from "./interface";

// TODO: similar code used on other places, move this to reusable utils
const getDateObj = (): DateMonthYearValue => {
  const dateObj = new Date();
  return {
    year: dateObj.getFullYear(),
    month: dateObj.getMonth() + 1, // getMonth() is zero-based
    day: dateObj.getDate(),
  };
};

export const storeData = (
  localValue: ClickStatData[] | null,
  setLocalValue: (value: ClickStatData[]) => void,
  clicks: number
): void => {
  const { year, month, day } = getDateObj();
  const obj = { clicks, year, month, day };

  if (!localValue) {
    setLocalValue([obj]);
  } else {
    const value = localValue.find((v) => compareDates(v, { year, month, day }));

    if (!value) {
      setLocalValue([...localValue, obj]);
    } else {
      setLocalValue(
        localValue.map((v) =>
          compareDates(v, { year, month, day })
            ? { ...v, clicks: v.clicks + 1 }
            : v
        )
      );
    }
  }
};

export default storeData;
